import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Calendar, User, Clock, ArrowRight, Search } from 'lucide-react';
export function BlogPage() {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const categories = ['All', 'Legal', 'Investment', 'Market Trends', 'How-To Guides'];
  const blogPosts = [{
    id: 1,
    title: 'Understanding RERA: A Complete Guide for Property Buyers',
    excerpt: 'Learn everything about Real Estate Regulatory Authority and how it protects your interests as a buyer.',
    category: 'Legal',
    author: 'Priya Sharma',
    date: '2024-01-15',
    readTime: '8 min read',
    image: '[Blog Image]'
  }, {
    id: 2,
    title: 'Top 10 Investment Locations in Pune for 2024',
    excerpt: 'Discover the most promising areas for plot investment in Pune with detailed market analysis and growth projections.',
    category: 'Investment',
    author: 'Amit Kumar',
    date: '2024-01-12',
    readTime: '6 min read',
    image: '[Blog Image]'
  }, {
    id: 3,
    title: 'How to Verify Land Documents: A Step-by-Step Checklist',
    excerpt: 'Essential documents you must verify before purchasing any plot. Avoid legal complications with our comprehensive checklist.',
    category: 'How-To Guides',
    author: 'Rajesh Patel',
    date: '2024-01-10',
    readTime: '10 min read',
    image: '[Blog Image]'
  }, {
    id: 4,
    title: 'Real Estate Market Trends: Q1 2024 Analysis',
    excerpt: 'Comprehensive analysis of current market trends, price movements, and future predictions for the Indian real estate sector.',
    category: 'Market Trends',
    author: 'Neha Singh',
    date: '2024-01-08',
    readTime: '12 min read',
    image: '[Blog Image]'
  }, {
    id: 5,
    title: 'NRI Property Investment: Tax Implications and Legal Requirements',
    excerpt: 'Everything NRIs need to know about investing in Indian real estate, including FEMA compliance and tax obligations.',
    category: 'Legal',
    author: 'Vikram Desai',
    date: '2024-01-05',
    readTime: '15 min read',
    image: '[Blog Image]'
  }];
  const filteredPosts = blogPosts.filter(post => {
    const matchesSearch = post.title.toLowerCase().includes(searchQuery.toLowerCase()) || post.excerpt.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesCategory = selectedCategory === 'all' || post.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });
  return <div className="min-h-screen bg-[#f5f5f7] font-sans text-[#1f2933] flex flex-col" data-id="element-2946">
      <header className="bg-white border-b border-gray-300 py-4 px-6 md:px-12" data-id="element-2947">
        <Link to="/" className="flex items-center gap-2" data-id="element-2948">
          <div className="w-8 h-8 bg-[#1f2933] rounded-sm" data-id="element-2949"></div>
          <span className="font-bold text-xl tracking-tight" data-id="element-2950">
            Citiplots.com
          </span>
        </Link>
      </header>

      <main className="flex-1 max-w-6xl mx-auto px-6 py-12" data-id="element-2951">
        <h1 className="text-4xl font-bold mb-4" data-id="element-2952">Blog & Insights</h1>
        <p className="text-lg text-gray-500 mb-8 font-mono" data-id="element-2953">
          Expert advice, market insights, and guides for property buyers
        </p>

        {/* Search & Filter */}
        <div className="bg-white border border-gray-300 p-6 mb-8" data-id="element-2954">
          <div className="flex flex-col md:flex-row gap-4" data-id="element-2955">
            <div className="flex-1 relative" data-id="element-2956">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-2957" />
              <input type="text" placeholder="Search articles..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-12 pr-4 py-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-2958" />
            </div>
            <div className="flex gap-2 flex-wrap" data-id="element-2959">
              {categories.map(cat => <button key={cat} onClick={() => setSelectedCategory(cat.toLowerCase())} className={`px-4 py-2 text-sm font-medium border ${selectedCategory === cat.toLowerCase() ? 'border-[#1f2933] bg-gray-50' : 'border-gray-300 hover:bg-gray-50'}`} data-id="element-2960">
                  {cat}
                </button>)}
            </div>
          </div>
        </div>

        {/* Blog Posts Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2961">
          {filteredPosts.map(post => <article key={post.id} className="bg-white border border-gray-300 hover:shadow-lg transition-shadow" data-id="element-2962">
              <div className="aspect-video bg-gray-100 border-b border-gray-300 flex items-center justify-center text-gray-400 font-mono" data-id="element-2963">
                {post.image}
              </div>
              <div className="p-6" data-id="element-2964">
                <div className="flex items-center gap-2 mb-3" data-id="element-2965">
                  <span className="px-2 py-1 bg-blue-50 text-blue-700 text-xs font-bold border border-blue-200" data-id="element-2966">
                    {post.category}
                  </span>
                  <span className="text-xs text-gray-500 font-mono flex items-center gap-1" data-id="element-2967">
                    <Clock className="w-3 h-3" data-id="element-2968" />
                    {post.readTime}
                  </span>
                </div>
                <h2 className="text-xl font-bold mb-2 hover:text-blue-600 cursor-pointer" data-id="element-2969">
                  {post.title}
                </h2>
                <p className="text-sm text-gray-600 mb-4 line-clamp-2" data-id="element-2970">
                  {post.excerpt}
                </p>
                <div className="flex items-center justify-between pt-4 border-t border-gray-200" data-id="element-2971">
                  <div className="flex items-center gap-2 text-xs text-gray-500" data-id="element-2972">
                    <User className="w-4 h-4" data-id="element-2973" />
                    <span data-id="element-2974">{post.author}</span>
                    <span data-id="element-2975">•</span>
                    <Calendar className="w-4 h-4" data-id="element-2976" />
                    <span data-id="element-2977">{post.date}</span>
                  </div>
                  <button className="text-sm font-bold text-blue-600 hover:text-blue-800 flex items-center gap-1" data-id="element-2978">
                    Read More <ArrowRight className="w-4 h-4" data-id="element-2979" />
                  </button>
                </div>
              </div>
            </article>)}
        </div>

        {filteredPosts.length === 0 && <div className="text-center py-12 bg-white border border-gray-300" data-id="element-2980">
            <p className="text-gray-500 font-mono" data-id="element-2981">
              No articles found matching your search
            </p>
          </div>}

        {/* Newsletter Signup */}
        <div className="mt-12 bg-white border border-gray-300 p-8 text-center" data-id="element-2982">
          <h3 className="text-2xl font-bold mb-2" data-id="element-2983">Stay Updated</h3>
          <p className="text-gray-600 mb-6" data-id="element-2984">
            Subscribe to our newsletter for the latest insights and market
            updates
          </p>
          <div className="flex gap-2 max-w-md mx-auto" data-id="element-2985">
            <input type="email" placeholder="Enter your email" className="flex-1 p-3 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-2986" />
            <button className="px-6 py-3 bg-[#1f2933] text-white font-bold hover:bg-gray-800" data-id="element-2987">
              Subscribe
            </button>
          </div>
        </div>
      </main>

      <Footer data-id="element-2988" />
    </div>;
}